export const FEATURE_OVERRIDE_ENABLED = 'featureOverrideEnabled';
export const FEATURE_PORSCHE_75_YEARS_LOGO = 'porsche_75_years_logo';
export const FEATURE_SHOP = 'shop';
export const FEATURE_PCOM_SEARCH = 'pcom_search';
export const FEATURE_SAVED_ITEMS = 'saved_items';
export const FEATURE_AB_TESTING = 'ab';

export const FEATURE_DEALER_SEARCH_CHINA = 'dealer_search_china';
export const FEATURE_DEALER_SEARCH_OPENING_HOURS = 'opening_hours';
export const FEATURE_SENTRY = 'sentry';
export const FEATURE_SHOP_WISHLIST = 'shop_wishlist';
export const FEATURE_FINDER_SHORTCUTS = 'finder_shortcuts';
export const FEATURE_CHINESE_CDN_CONTENT_REQUEST = 'cn_cdn';
